import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AdminPermissionObj } from 'src/app/interfaces/utsav-permission-interface';
import { EncryptService } from '../Encrypt/encrypt.service';
import * as CryptoJS from 'crypto-js';
import * as XLSX from 'xlsx';

enum AdminTypes {
  mandirUser = 'Mandir User', // POST_CREATER
  mandirAdmin = 'Mandir Admin', //MANDIR_ADMIN
  utsavAdmin = 'Utsav Admin', // UTSAV_PERM_APPROVER
  noticeAdmin = 'Notice Admin', // NOTICE_CREATOR
  postApprover = 'Post Approval Admin', // POST_APPROVER,
  magazineAdmin = 'Magazine Admin',
}

const AdminPermissions: Array<AdminPermissionObj> = [
  {
    type: AdminTypes.mandirAdmin,
    availableRoutes: [],
    baseRoute: '/user/mandir-admin/admin-home',
  },
  {
    type: AdminTypes.mandirUser,
    availableRoutes: [
      '/user/mandir-admin/home',
      '/user/mandir-admin/create-post',
      '/user/mandir-admin/my-posts',
    ],
    baseRoute: '/user/mandir-admin/home',
  },
  {
    type: AdminTypes.utsavAdmin,
    availableRoutes: [
      // '/user/utsav-admin',
      '/user/utsav-admin/requests',
      '/user/utsav-admin/calendar',
    ],
    baseRoute: '/user/utsav-admin/requests',
  },
  {
    type: AdminTypes.postApprover,
    availableRoutes: ['/user/mandir-admin/post-approval'],
    baseRoute: '/user/mandir-admin/post-approval',
  },
  {
    type: AdminTypes.noticeAdmin,
    availableRoutes: [''],
    baseRoute: '',
  },
  {
    type: AdminTypes.magazineAdmin,
    availableRoutes: [
      '/user/magazine-admin/magazine-order',
      '/user/magazine-admin/active-subscription',
      '/user/magazine-admin/order-tracking',
    ],
    baseRoute: '/user/magazine-admin/magazine-order',
  },
];
@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor(
    private router: Router,
    private platformLocation: PlatformLocation,
    private encrypService: EncryptService,
  ) {}

  /**
   * Shows success
   * @param msg
   */
  showSuccess(msg: string) {
    var toast = document.createElement('div');
    toast.classList.add('toast-proclamation');
    var img = document.createElement('img');
    var p = document.createElement('p');
    img.src = '../../../../assets/Images/check-line.svg';
    img.alt = 'info icon';
    p.innerHTML = msg;
    toast.appendChild(img);
    toast.appendChild(p);
    document.getElementById('toast-container')?.appendChild(toast);
    setTimeout(function () {
      toast.classList.add('fade-out');
      setTimeout(function () {
        toast.remove();
      }, 500);
    }, 3000);
  }

  /**
   * Shows error
   * @param msg
   */
  showError(msg: string) {
    var toast = document.createElement('div');
    toast.classList.add('toast-proclamation');
    // var img = document.createElement('img');
    var p = document.createElement('p');
    // img.src = '../../../../assets/OblateRegister/backIcon.svg';

    // img.alt = 'info icon';
    p.innerHTML = msg;
    // toast.appendChild(img);
    toast.appendChild(p);
    document.getElementById('toast-container')?.appendChild(toast);
    setTimeout(function () {
      toast.classList.add('fade-out');
      setTimeout(function () {
        toast.remove();
      }, 500);
    }, 10000);
  }
  showGetOTP(msg: string) {
    var toast = document.createElement('div');
    toast.classList.add('toast-proclamation-establishment');
    var img = document.createElement('img');
    var p = document.createElement('p');
    img.src = '../../../../assets/OblateRegister/backIcon.svg';

    img.alt = 'info icon';
    p.innerHTML = msg;
    toast.appendChild(img);
    toast.appendChild(p);
    document.getElementById('toast-container')?.appendChild(toast);
    setTimeout(function () {
      toast.classList.add('fade-out');
      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 4000);
  }

  /**
   * Handles error
   * @template T
   * @param [operation]
   * @param [result]
   * @returns
   */
  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T | null> => {
      console.log('ERRORRR : ', error);
      // console.log(
      //   'ERROR : ',
      //   JSON.parse(
      //     CryptoJS.AES.decrypt(
      //       error?.error?.text,
      //       // error?.error,
      //       'ENCRYPT_SECRET_KEY',
      //     ).toString(CryptoJS.enc.Utf8),
      //   ),
      // );
      if (error?.error?.message) {
        this.showError(error.error.message);
      } else {
        this.showError(error.statusText);
      }
      return of(result as T);
    };
  }

  get baseHref() {
    return (this.platformLocation as any).location.origin;
  }

  get currentRouteUrl() {
    return (this.platformLocation as any).location.pathname;
  }

  getAdminType(): AdminPermissionObj[] {
    let currAdminTypes: any = [];
    if (localStorage.getItem('permissionsObj')) {
      const permissionArr: any = localStorage.getItem('permissionsObj');
      if (permissionArr.includes('POST_APPROVER')) {
        currAdminTypes.push(AdminTypes.postApprover);
      }
      if (permissionArr.includes('UTSAV_PERM_APPROVER')) {
        currAdminTypes.push(AdminTypes.utsavAdmin);
      }
      if (permissionArr.includes('POST_CREATER')) {
        currAdminTypes.push(AdminTypes.mandirUser);
      }
      if (permissionArr.includes('CAN_WITHDRAW_MANDIR_FUNDS')) {
        currAdminTypes.push(AdminTypes.mandirAdmin);
      }
      if (permissionArr.includes('NOTICE_CREATOR')) {
        currAdminTypes.push(AdminTypes.noticeAdmin);
      }
      if (permissionArr.includes('CAN_VIEW_ORDER_DETAILS')) {
        currAdminTypes.push(AdminTypes.magazineAdmin);
      }
      // yet to be set -------------------------------------------------
      if (permissionArr.includes('MANDIR_DOC_UPLOADER')) {
        currAdminTypes.push(AdminTypes.magazineAdmin);
      }
    }
    return AdminPermissions.filter(
      (item) => currAdminTypes.indexOf(item.type) !== -1,
    ) as AdminPermissionObj[];
  }

  cleanValue(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).trim();
  }
  normalizeStatus(value: any): string {
    return this.cleanValue(value).toUpperCase();
  }
  normalizeBoolean(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    const normalized = String(value).trim().toLowerCase();
    return ['true', 'yes', 'y', '1'].includes(normalized);
  }
  normalizeDate(value: any): string {
    if (!value) {
      return '';
    }
    if (value instanceof Date) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, '0');
      const day = String(value.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    // Excel serial date fallback
    if (typeof value === 'number') {
      return this.formatExcelDate(value);
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  formatExcelDate(serial: number): string {
    const date = XLSX.SSF.parse_date_code(serial);
    if (!date) {
      return '';
    }
    const year = date.y;
    const month = String(date.m).padStart(2, '0');
    const day = String(date.d).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  downloadTemplate(): void {
    const template = [
      {
        name: 'Puja Utsav',
        location: 'Satsang Ashram, Deoghar',
        startDate: '2026-10-18',
        endDate: '2026-10-22',
        status: 'ACTIVE',
        accommodationFlag: 'ACTIVE',
        bookingStartDate: '2026-09-01',
        bookingEndDate: '2026-10-15',
        isBookingRequired: true,
        imageUrl: '',
      },
    ];
    const worksheet = XLSX.utils.json_to_sheet(template);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Utsav');
    XLSX.writeFile(workbook, 'utsav-upload-template.xlsx');
  }
}
